<%= form_with(model: entry, class: "contents") do |form| %>
  <% if entry.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(entry.errors.count, "error") %> prohibited this entry from being saved:</h2>

      <ul class="list-disc ml-6">
        <% entry.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :lead_id %>
    <%= form.text_field :lead_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": entry.errors[:lead_id].none?, "border-red-400 focus:outline-red-600": entry.errors[:lead_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :follow_id %>
    <%= form.text_field :follow_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": entry.errors[:follow_id].none?, "border-red-400 focus:outline-red-600": entry.errors[:follow_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :instructor_id %>
    <%= form.text_field :instructor_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": entry.errors[:instructor_id].none?, "border-red-400 focus:outline-red-600": entry.errors[:instructor_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :age_id %>
    <%= form.text_field :age_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": entry.errors[:age_id].none?, "border-red-400 focus:outline-red-600": entry.errors[:age_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :level_id %>
    <%= form.text_field :level_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": entry.errors[:level_id].none?, "border-red-400 focus:outline-red-600": entry.errors[:level_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :studio_id %>
    <%= form.text_field :studio_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": entry.errors[:studio_id].none?, "border-red-400 focus:outline-red-600": entry.errors[:studio_id].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
